import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import getV1StockAutoOrder from '@services/api/stock/order/auto/order';

function useAutoOrder({ accountType = 'REG', refetchOnMount = false } = {}) {
  const { cb, key } = getV1StockAutoOrder({ accountType, pageSize: 10 });

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.next && allPages.length + 1;
    },
    select: (_data) => _data.pages?.flatMap((page) => page?.results || []),
    refetchOnMount,
    refetchInterval: 10_000,
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default useAutoOrder;
